import React, { useContext, useState, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { SalePropContext } from '../components/a-sale';
import ImgPicture from '../components/img-picture';
/**
 * GA4用のコンソールIDを返す
 */
const consoleName = (type) => {
    switch (type) {
        case 'ps4':
        case 'ps5':
            return type.toUpperCase();
        case 'ns':
            return 'Switch';
    }
    return '';
};
const SaleItemNav = ({ type, url, endOfSale, itemNumber, gaPrefix }) => {
    const saleProp = useContext(SalePropContext);
    const [alt, setAlt] = useState();
    const [className, setClassName] = useState(classNames('nav-goto-store', type));
    // GA4用のユニークなIDを生成する
    const idName = useMemo(() => {
        if (!gaPrefix) {
            return `SALE_${consoleName(type)}_${itemNumber}`;
        }
        return `${gaPrefix}_${consoleName(type)}_${itemNumber}`;
    }, [
        type,
        gaPrefix
    ]);
    // セール終了の場合は無効状態のCSSクラスを付与
    useEffect(() => {
        if (saleProp?.sale_status === 2 || endOfSale) {
            setClassName(classNames('nav-goto-store', type, 'disabled'));
        }
    }, [
        endOfSale, saleProp
    ]);
    // Altを設定
    useEffect(() => {
        switch (type) {
            case 'ps5':
                setAlt('PlayStation&reg;5');
                break;
            case 'ps4':
                setAlt('PlayStation&reg;4');
                break;
            case 'ns':
                setAlt('Nintendo Switch');
                break;
            case 'ds':
                setAlt('Nintendo 3DS');
                break;
        }
    }, [
        type
    ]);
    return (React.createElement("a", { className: className, id: idName, href: url, target: "_blank", rel: "noopener" },
        React.createElement(ImgPicture, { fileName: `./assets/img/misc/logo/${type}`, alt: alt })));
};
export default SaleItemNav;
